const veevalidate = require('vee-validate');

const { defineRule } = veevalidate;

module.exports = function () {
  /* ***** */
  /* LOGIN */
  /* ***** */

  defineRule('username', (value) => {
    if (!value) {
      return 'Please enter a first name';
    }
    return true;
  });

  defineRule('password', (value) => {
    if (!value) {
      return 'Please enter a password';
    } if (value.length < 7) {
      return 'Must be more than 7 characters';
    } if (value.length > 16) {
      return 'Must be less than 16 characters';
    } if (!/^[a-zA-Z0-9~`!@#$%^&*(){}[\]:;"'<>?+]*$/.test(value)) {
      return 'No spaces or , - | \\ / = _';
    } if (!/^(?=.*[A-Z])/.test(value)) {
      return 'Must contain at least one uppercase';
    } if (!/^(?=.*[a-z])/.test(value)) {
      return 'Must contain at least one lowercase';
    } if (!/^(?=.*[0-9])/.test(value)) {
      return 'Must contain at least one numeric';
    }
    return true;
  });

  defineRule('passwordConfirm', (value, [password]) => {
    if (!value) {
      return 'This is required';
    } if (value !== password) {
      return 'Password doesn\'t match';
    }
    return true;
  });
  defineRule('signInPassword', (value) => {
    if (!value) {
      return 'Please enter your password';
    } if (value.length < 7) {
      return 'Must be more than 7 characters';
    } if (value.length > 16) {
      return 'Must be less than 16 characters';
    } if (!/^[a-zA-Z0-9~`!@#$%^&*(){}[\]:;"'<>?+]*$/.test(value)) {
      return 'No spaces or , - | \\ / = _';
    }
    return true;
  });

  defineRule('termsAndConditions', (value) => {
    if (!value) {
      return 'You must accept the terms and conditions';
    }
    return true;
  });

  /* **** */
  /* NAME */
  /* **** */

  defineRule('firstName', (value, [key]) => {
    if (!value) {
      return `Enter your ${key ? `${key } ` : ''}first name`;
    } if (value.length > 20) {
      return 'Must be less than 20 characters';
    } if (!/^[-a-zA-Z'\u2018\u2019\s.]*$/.test(value)) {
      return "No special characters except - ' .";
    }
    return true;
  });

  defineRule('lastName', (value, [key]) => {
    if (!value) {
      return `Enter your ${key ? `${key } ` : ''}last name`;
    } if (value.length > 30) {
      return 'Must be less than 30 characters';
    } if (!/^[-a-zA-Z'\u2018\u2019\s.]*$/.test(value)) {
      return "No special characters except - ' .";
    }
    return true;
  });

  /* ******* */
  /* ADDRESS */
  /* ******* */

  defineRule('addressLine1', (value) => {
    if (!value) {
      return 'Enter an address';
    } if (value.length > 35) {
      return 'Must be less than 35 characters';
    } if (!/^[-a-zA-Z'\s#/.0-9]*$/.test(value)) {
      return 'Cannot support special character(s)';
    }
    return true;
  });

  defineRule('addressLine2', (value) => {
    if (!value || !value.length) {
      return true;
    } if (value.length > 35) {
      return 'Must be less than 35 characters';
    } if (!/^[-a-zA-Z'\s#/.0-9]*$/.test(value)) {
      return 'Cannot support special character(s)';
    }
    return true;
  });

  defineRule('city', (value) => {
    if (!value) {
      return 'Enter your city';
    } if (value.length > 25) {
      return 'Must be less than 25 characters';
    } if (!/^[-a-zA-Z'\s'/.0-9]*$/.test(value)) {
      return 'Cannot support special character(s)';
    }
    return true;
  });

  defineRule('state', (value) => {
    if (!value) {
      return 'Select a state';
    }
    return true;
  });

  defineRule('zipCode', (value) => {
    if (!value) {
      return 'Enter your zip code';
    } if (value.length !== 5) {
      return 'Enter a valid 5-digit ZIP code';
    } if (!/\d{5}/.test(value)) {
      return 'Enter a valid 5-digit ZIP code';
    }
    return true;
  });

  /* ************ */
  /* CONTACT INFO */
  /* ************ */

  defineRule('phone', (value, [phoneLength = 10]) => {
    if (!value) {
      return `Enter a ${phoneLength}-digit phone number`;
    } if (value.replace(/[() -]/g, '').length !== phoneLength) {
      return `Enter a ${phoneLength}-digit phone number`;
    } if (!/^[0-9*]+$/.test(value.replace(/[() -]/g, ''))) {
      return 'No special characters';
    }
    return true;
  });

  defineRule('email', (value) => {
    const STRICT_EMAIL_CHECK_PATTERN = '^[A-Za-z0-9]+(?!.*?--)(\\.[A-Za-z0-9-]+|\\-[A-Za-z0-9-]+|\\_[A-Za-z0-9-]+|\\+[A-Za-z0-9-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[a-zA-Z]{2,10})$';
    if (!value) {
      return 'Enter your email address';
    } if (value.length > 75) {
      return 'Must be less than 75 characters';
    } if (!(new RegExp(STRICT_EMAIL_CHECK_PATTERN).test(value))) {
      return 'Enter in this format: jane@email.com';
    }
    return true;
  });

  defineRule('emailConfirm', (value, [email]) => {
    if (!value) {
      return 'This is required';
    } if (value !== email) {
      return "Email doesn't match";
    }
    return true;
  });

  /* ************ */
  /* PAYMENT INFO */
  /* ************ */

  defineRule('cardNumber', (value) => {
    if (!value) {
      return 'Enter a card number';
    } if (value.length < 10 || value.length > 24) {
      return 'Enter a valid card number';
    } if (!/^(?=.*\d)[*\d ]+$/.test(value)) {
      return 'No special characters';
    }
    return true;
  });

  defineRule('cardType', (value) => {
    if (!value) {
      return 'Select a card type';
    }
    return true;
  });

  defineRule('expMonth', (value) => {
    if (!value) {
      return 'Select a month';
    }
    return true;
  });

  defineRule('expYear', (value) => {
    if (!value) {
      return 'Select a year';
    }
    return true;
  });

  defineRule('securityCode', (value) => {
    if (!value) {
      return 'Enter the security code';
    } if (value.length !== 3) {
      return 'Enter a valid 3-digit security code';
    } if (!/^[0-9*]+$/.test(value)) {
      return 'Remove any special characters.';
    }
    return true;
  });

  defineRule('amexRule', (value) => {
    if (!value) {
      return 'Enter the security code for your card';
    } if (value.length !== 4) {
      return 'Enter a valid 4-digit security code';
    } if (!/^[0-9*]+$/.test(value)) {
      return 'Remove any special characters.';
    }
    return true;
  });

  /* ********** */
  /* GIFT CARDS */
  /* ********** */

  defineRule('giftCardNumber', (value) => {
    if (!value) {
      return 'Please enter a card number.';
    } if (value.length > 16) {
      return 'Card Number cannot exceed 16 digits.';
    } if (!/^[0-9*]+$/.test(value)) {
      return 'Please remove any special characters.';
    }
    return true;
  });

  defineRule('giftCardCidNumber', (value) => {
    if (!value) {
      return 'Please enter the 3 to 4 digit CID on your Gift or Rewards Card.';
    } if (value.length < 3) {
      return 'CID should be at least 3 digits.';
    } if (value.length > 4) {
      return 'CID cannot exceed 4 digits.';
    } if (!/^[0-9*]+$/.test(value)) {
      return 'Please remove any special characters.';
    }
    return true;
  });

  defineRule('captcha', (value) => {
    if (!value) {
      return 'Please enter the characters as shown.';
    } if (value.length !== 6) {
      return 'Captcha should be 6 characters.';
    } if (!/^[a-zA-Z0-9]+$/.test(value)) {
      return 'Please remove any special characters.';
    }
    return true;
  });

  defineRule('giftPrice', (value) => {
    if (!value) {
      return 'Please use an amount from $10 to $1,000';
    } if (!/^\$?(?:[1-9]\d{1,2}(?:\.\d{1,2})?|10(\.00?)?|1000(\.00?)?)$/.test(value)) {
      return 'Please use an amount from $10 to $1,000';
    }
    return true;
  });

  defineRule('giftQuantity', (value) => {
    if (!value) {
      return 'Please select quantity between 1 to 12';
    } if (!/^[1-9]$/.test(value)) {
      return 'Please select quantity between 1 to 12';
    }
    return true;
  });

  defineRule('giftToFrom', (value) => {
    if (!value || !value.length) {
      return true;
    } if (value.length > 60) {
      return 'Cannot exceed 60 characters.';
    } if (!/^[a-zA-Z0-9.!\s]*$/.test(value)) {
      return 'You may use letters, numbers, exclamation points and periods.';
    }
    return true;
  });

  defineRule('giftMessage', (value) => {
    if (!value || !value.length) {
      return true;
    } if (value.length > 60) {
      return 'This message can be 60 characters or less';
    }
    return true;
  });

  /* ********* */
  /* LOYALLIST */
  /* ********* */

  defineRule('loyallistNumber', (value) => {
    if (!value) {
      return 'Please enter Loyallist Number.';
    } if (value.length > 13) {
      return 'Loyallist Number may not contain more than 13 characters';
    } if (!/^L\d{12}$/.test(value)) {
      return "Please check your Loyallist Number. It must begin with an 'L' followed by 12 numeric digits.";
    }
    return true;
  });

  defineRule('coBrandCreditCard', (value) => {
    if (!value) {
      return "Bloomingdale's Credit Card may not contain less than 12 characters";
    } if (value.length < 12) {
      return "Bloomingdale's Credit Card may not contain less than 12 characters";
    } if (value.length > 16) {
      return '';
    } if (!/\d* /.test(value)) {
      return '';
    }
    return true;
  });

  /* ***** */
  /* DATES */
  /* ***** */

  defineRule('month', (value) => {
    if (!value) {
      return 'Select a month';
    }
    return true;
  });

  defineRule('day', (value) => {
    if (!value) {
      return 'Select a day';
    }
    return true;
  });

  defineRule('year', (value) => {
    if (!value) {
      return 'Select a year';
    }
    return true;
  });

  defineRule('dateOfBirth', (value) => {
    if (!value) {
      return 'Enter your date of birth';
    } if (!/^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(value)) {
      return 'Enter a valid date of birth';
    }
    return true;
  });

  /* ******* */
  /* REVIEWS */
  /* ******* */

  defineRule('reviewNickname', (value) => {
    if (!value) {
      return 'Please enter at least one character.';
    } if (!/^[a-zA-Z0-9]*$/.test(value)) {
      return 'Your nickname can only contain letters and numbers.';
    }
    return true;
  });

  defineRule('reviewText', (value) => {
    if (!value) {
      return 'You must write at least 50 characters for this field.';
    } if (value.length < 50) {
      return 'You must write at least 50 characters for this field.';
    } if (value.length > 1000) {
      return 'Cannot exceed 1000 characters.';
    }
    return true;
  });

  defineRule('reviewTitle', (value) => {
    if (!value) {
      return 'You must enter a title.';
    } if (value.length > 50) {
      return 'Cannot exceed 50 characters.';
    } if (!/^[a-zA-Z0-9.!\s]*$/.test(value)) {
      return 'You may use letters, numbers, exclamation points and periods.';
    }
    return true;
  });

  defineRule('last4SSN', (value) => {
    if (!value) {
      return 'Enter last 4-digits SSN';
    } if (value.length !== 4) {
      return 'Enter valid last 4-digits SSN';
    } if (!/\d{4}/.test(value)) {
      return 'Enter valid last 4-digits SSN';
    }
    return true;
  });

  defineRule('registrySearch', (value) => {
    const newValue = value?.trim();
    if (!newValue) {
      return 'Enter your registry id or full name';
    } if (/^[0-9\s!-'.]*$/.test(newValue) && !/^[0-9]*$/.test(newValue)) { // checking the value: is it number or combination of symbols and numbers
      return 'No special characters are allowed in registry id';
    } if (!/^[-a-zA-Z0-9\s.']*$/.test(newValue)) {
      return 'No special characters except - . and \'';
    } if (newValue.length < 2) {
      return 'Must be minimum 2 characters';
    } if (/\s\s/.test(newValue)) {
      return 'No 2 consecutive spaces allowed';
    }
    return true;
  });

  // this rule only use on seller-hub to stop entering more that max limit, but no need to display error message for empty.
  defineRule('fileDescription', () => true);
};
